"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSearchInfo = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const lodash_1 = require("lodash");
const react_router_dom_1 = require("react-router-dom");
const Highlight_1 = require("../Highlight");
const GlobalSearchResultElement = (0, material_1.styled)("div")(({ theme }) => ({
    padding: theme.spacing(1),
    width: "100%",
}));
const GlobalSearchResultLink = (0, material_1.styled)(react_router_dom_1.Link)({
    textDecoration: "none",
    color: "inherit",
});
const GlobalSearchResultBottom = (0, material_1.styled)("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(0.5),
}));
const GlobalSearchResultTop = (0, material_1.styled)("div")({
    display: "flex",
    justifyContent: "space-between",
});
const GlobalSearchResultHighlight = (0, material_1.styled)(Highlight_1.Highlight)(({ theme }) => ({
    backgroundColor: (0, lodash_1.get)(theme, "palette.dashboard.sunrise"),
}));
const GlobalSearchResultLabel = (0, material_1.styled)("div")(({ theme }) => ({
    opacity: 0.5,
    fontSize: "12px",
    marginBottom: theme.spacing(0.5),
}));
const formatSearchInfo = (info) => info.map(({ label, value, highlight }, index) => (react_1.default.createElement("div", { key: `${label}-${value}-${index}` },
    react_1.default.createElement(GlobalSearchResultLabel, null, label),
    highlight ? (react_1.default.createElement(GlobalSearchResultHighlight, { search: highlight, text: value })) : (react_1.default.createElement("div", null, value)))));
exports.formatSearchInfo = formatSearchInfo;
exports.default = ({ link, topInfo = [], bottomInfo = [], handleSelection, }) => (react_1.default.createElement(GlobalSearchResultElement, null,
    react_1.default.createElement(GlobalSearchResultLink, { to: link, onClick: handleSelection },
        react_1.default.createElement(GlobalSearchResultTop, null, (0, exports.formatSearchInfo)(topInfo)),
        react_1.default.createElement(GlobalSearchResultBottom, null, (0, exports.formatSearchInfo)(bottomInfo)))));
